<script setup>
defineProps({
  body: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div class="text-privacy">
    <div class="row-270-20 p-bot-1 max">
      <div class="main-section">
        <!-- eslint-disable vue/no-v-html -->
        <h1 class="heading-1 intro-page">INFORMATIVA PRIVACY</h1>
        <div v-html="body" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyBody',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
